import api from './axiosConfig';

export interface AdminCampaign {
  /** キャンペーン識別子（例: seedance_2_5_half） */
  key: string;
  label: string;
  description: string;
  /** 管理者がオンにしているか */
  is_enabled: boolean;
  /** オンかつ終了日を過ぎていない＝いま割引が効いている */
  is_active: boolean;
  /** 消費クレジットに掛ける係数。0.5 = 半額 */
  discount_rate: number;
  /** 最終日（YYYY-MM-DD）。この日いっぱいまで有効 */
  ends_at: string | null;
  updated_at: string | null;
}

export interface AdminCampaignPayload {
  is_enabled: boolean;
  ends_at: string | null;
}

export interface AdminCampaignListResponse {
  success: boolean;
  data: { campaigns: AdminCampaign[] };
}

export interface AdminCampaignUpdateResponse {
  success: boolean;
  data: { campaign: AdminCampaign };
}

const adminCampaignService = {
  async list(): Promise<AdminCampaignListResponse> {
    const response = await api.get<AdminCampaignListResponse>('/admin/campaigns');
    return response.data;
  },

  async update(key: string, payload: AdminCampaignPayload): Promise<AdminCampaignUpdateResponse> {
    const response = await api.put<AdminCampaignUpdateResponse>(`/admin/campaigns/${key}`, payload);
    return response.data;
  },
};

export default adminCampaignService;
